<ngx-simplebar class="responsiveScrollContainer h-full">
  <div class="statisticsPage container">
    <ngx-simplebar class="widget gatePositionChart">
      <app-gate-position-chart
        [openCountState]="statisticsFacade.openCount()"
        [partiallyOpenCountState]="statisticsFacade.partiallyOpenCount()"
        [closedCountState]="statisticsFacade.closedCount()"
        [chartId]="'statisticsGatePositionChart'"
      ></app-gate-position-chart>
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false }" class="widget">
      <app-available-gates-doughnut-chart
        [availableCountState]="statisticsFacade.availableCount()"
        [totalCountState]="statisticsFacade.totalCount()"
        chartId="statisticsAvailableGatesDoughnutChart"
      ></app-available-gates-doughnut-chart>
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false, forceVisible: 'y' }" class="widget flex flex-column p-3 gap-2">
      <app-gate-fault-frequency
        [aspectRatio]="1.9"
        chartId="statisticsFaultFrequencyChart"
        [gateFaultSource]="statisticsFacade.gateFaultState()"
        style="flex: 1"
      ></app-gate-fault-frequency>
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false }" class="widget">
      <app-energy-loss-yearly-chart
        [chartData]="statisticsFacade.lineChartEnergyLoss()"
        chartId="yearlyEnergyLossChartStats"
      ></app-energy-loss-yearly-chart>
    </ngx-simplebar>
  </div>
</ngx-simplebar>
